import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_ZTICKTRACE_SCHEMA_LITERAL = {
    title: 'Schéma TRACE',
    description: 'TRACE',
    version: 0,
    keyCompression: false,
    primaryKey: 'TRACE_GID',
    type: 'object',
    properties: {
        TRACE_GID : { type : 'string', maxLength : 50 },
        TRACE_DATEEVENT : { type : 'string' }, 
        DO_PIECE_INTERNAL : { type : 'string' }, 
        TRACE_EVT_DATA : { type : 'string' }, 
        TRACE_EVT_DATA_RXDB : { type : 'string' }, 
        USER_GID : { type : 'string' }, 
        MD_SITEGID : { type : 'string' },
        MD_SITE_LIB : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSE_LIB : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER_LIB : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_SITE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        ZSYNCUP_FLAG  : { type : 'number', default : 0 },
        ZSYNCUP_STATUS  : { type : 'string' },
        ZSYNCUP_ERROR_MESSAGE  : { type : 'string' },
        ZSYNCUP_DATETIME  : { type : 'string' },
        ZSYNCUP_FEEDID  : { type : 'string' }
    },
    required: [ 'TRACE_GID' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_ZTICKTRACE_SCHEMA_LITERAL);
export type RxCluZTickTraceDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_ZTICKTRACE_SCHEMA: RxJsonSchema<RxCluZTickTraceDocumentType> = CLU_ZTICKTRACE_SCHEMA_LITERAL;
